import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import {connect} from "react-redux";
import {getHomeInternalUrl} from "../../constants/appRoutes";
import {setRedirectUrl} from "../../state/miscellaneous/miscellaneousActions";

const mapDispatchToProps = dispatch => ({
  setRedirectUrl: url => dispatch(setRedirectUrl(url))
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  componentDidCatch(error, info) {
    this.setState({hasError: true});
  }

  render() {
    const {setRedirectUrl} = this.props;
    if (this.state.hasError) {
      return (
        <Box
          id="error-boundary__error-box"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            position: "absolute",
            width: "100%",
            overflow: "hidden",
            fontSize: "24px",
            color: "white"
          }}
        >
          <div>
            <Grid
              container
              justifyContent="center"
              sx={{
                marginBottom: theme => theme.spacing(1),
                fontSize: "38px"
              }}
            >
              <Grid>
                <ErrorOutlineIcon fontSize="inherit" />
              </Grid>
            </Grid>
            <Grid container justifyContent="center">
              <Grid>Something went wrong</Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              sx={theme => ({
                marginTop: theme.spacing(2),
                textDecoration: "underline",
                cursor: "pointer",
                color: theme.palette.secondary.main
              })}
            >
              <Grid>
                <div
                  onClick={() => {
                    setRedirectUrl(getHomeInternalUrl());
                    window.location.reload();
                  }}
                >
                  Go to home
                </div>
              </Grid>
            </Grid>
          </div>
        </Box>
      );
    } else {
      return this.props.children;
    }
  }
}

export default connect(null, mapDispatchToProps)(ErrorBoundary);
